import React from "react";
import styles from './PageTitle.module.scss';
import PropTypes from "prop-types";

const PageTitle = ({ 
  label
}) => {
  return (
    <div className={styles.title}>
      <h1>{label}</h1>
    </div>
  );
};

PageTitle.propTypes = {
  label: PropTypes.string.isRequired,
};

export default PageTitle;